import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { ToastService } from '../../services/toast/toast.service';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'evc-toast',
  imports: [IconComponent, ButtonComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  readonly toastClosed = output();
  readonly toastService = inject(ToastService);

  closeToast(id: string): void {
    this.toastClosed.emit();
    if (id) this.toastService.remove(id);
  }
  pauseToast(id: string): void {
    this.toastService.pause(id);
  }

  resumeToast(id: string): void {
    this.toastService.resume(id);
  }
}
